import Cookies from 'js-cookies';

export default function popInModule() {
  let delay = 30;
  const now = Date.now();
  const stamp = Cookies.getItem('startup-popin');
  if (stamp === 'debug') (delay = 0);
  else if (/^\d+$/.test(stamp) && (now - stamp < 7 * 24 * 3600 * 1000) ) return;
  setTimeout(() => {
    if (stamp !== 'debug') Cookies.setItem('startup-popin', now, 365, '/');
    jQuery.fancybox.open({src: '#startup-popin', type : 'inline'});
  }, delay * 1000);
}



// WEBPACK FOOTER //
// ./scripts/modules/startup-popin.js